import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Navbar.css';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Navbar = () => {

    const phoneNumber = '+5511955881602';

    const currentTime = new Date();
    let greeting;

    if (currentTime.getHours() < 12) {
      greeting = 'Bom dia!';
    } else if (currentTime.getHours() < 18) {
      greeting = 'Boa tarde!';
    } else {
      greeting = 'Boa noite!';
    }

    const message = encodeURIComponent(`${greeting} Eu vim pelo site da academia e gostaria de saber mais sobre os serviços.`);

    const whatsappLink = `https://wa.me/${phoneNumber}/?text=${message}`;

    const handleWhatsappClick = () => {
        window.open(whatsappLink, '_blank');
    };

    return(
        <>
            <section id="navbar">
            <nav class="navbar navbar-expand-lg bg-dark navbar-dark">
            <div class="container-fluid">
                <Link to={{ pathname: `/` }}>
                <a class="navbar-brand"><img src={`${process.env.PUBLIC_URL}/logo.svg`} alt=""/></a></Link>
                {/* <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                    <FontAwesomeIcon icon={faBars} />
                </button>
                <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel"><img src={`${process.env.PUBLIC_URL}/logo.svg`} /> ADK Shotokan</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                        <li class="nav-item" id="login">
                            <Link to="footer" smooth={true} duration={500} offset={-100} >
                                <a class="nav-link" >Contato</a>
                            </Link>
                        </li>
                    </ul>
                </div>
                </div> */}
            </div>
            </nav>

            </section>

            <button class="whatsapp-contact" onClick={handleWhatsappClick}>
                <FontAwesomeIcon icon={faWhatsapp} />
            </button>
        </>
    )

};

export default Navbar;
